/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("./Model.js");
var assign = require("object-assign");
var raf = require("raf");
var xtend = require("xtend");

assign(make_debounced_model, Model);

module.exports = make_debounced_model;

function make_debounced_model(settings) {
	return Model(xtend(settings, {
		__debouncing: false,
		push: saveAndPush
	}));
}

function saveAndPush(data) {
	this.data = data;

	if (this.__debouncing) return;

	this.__debouncing = raf(dispatchUpdate.bind(this));
}

function dispatchUpdate() {
	var data = this.data;
	this.__debouncing = false;
	this.dispatch("updated", data);
}
